module.exports = __webpack_public_path__ + "img/agriculture-24.76b955cd.svg";